// Helpers for deciding which classes can still be linked to a pass / assigned to a
// student. A class that has fully ended (its last scheduled session is in the past)
// has no remaining sessions to attend, so offering it for a new pass/assignment is
// meaningless — and a pass linked only to ended classes is immediately treated as
// expired by the booking layer. These helpers keep the selection dropdowns showing
// only the classes that actually make sense, consistently across the app.

export const todayDateString = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;
};

/**
 * True when the class still has at least one session today or in the future.
 * Classes with no schedule are treated as selectable (we can't determine an end).
 * `scheduledDates` are "YYYY-MM-DD" strings, which compare correctly as strings.
 */
export const isClassSelectable = (
  cls: { scheduledDates?: string[] | null } | null | undefined,
  today: string = todayDateString(),
): boolean => {
  const dates = cls?.scheduledDates;
  if (!Array.isArray(dates) || dates.length === 0) return true;
  const latest = dates.reduce((max, d) => (d > max ? d : max), dates[0]);
  return latest >= today;
};
